




















export default {
  name: "EstablishmentStateSignalingSent"
  props: {
    review:{
      type: Object
    },
  },
}
